module.exports = __webpack_public_path__ + "static/camera5-e960050e19f34c769d0c3a0a30c53ac2.jpg";